import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Point } from '../../../context/context';
import { logEvent } from '../../../services/analytics';

interface PointContextMenuProps {
    contextMenu: { x: number, y: number, point: Point } | null;
    onClose: () => void;
    onEditStyle: (point: Point) => void;
}

export default function PointContextMenu({
    contextMenu,
    onClose,
    onEditStyle
}: PointContextMenuProps) {
    const { t } = useTranslation('map');
    if (!contextMenu) return null;

    const handleEditStyle = () => {
        logEvent({
            category: 'Transit Analysis',
            action: 'PointContextMenuEditStyle',
            label: contextMenu.point.name || 'Unnamed Point',
            point_id: contextMenu.point.id,
            point_coordinates: `${contextMenu.point.coordinates[0]},${contextMenu.point.coordinates[1]}`
        });
        onEditStyle(contextMenu.point);
        onClose();
    };

    return (
        <Menu
            open={Boolean(contextMenu)}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={
                contextMenu
                    ? { top: contextMenu.y, left: contextMenu.x }
                    : undefined
            }
            PaperProps={{
                sx: {
                    boxShadow: 3,
                    minWidth: 120,
                }
            }}
        >
            <MenuItem onClick={handleEditStyle}>
                {t('contextMenu.editPointStyle')}
            </MenuItem>
        </Menu>
    );
} 